import React, { Fragment, useEffect, useState, useRef } from 'react';
import moment from 'moment';
import { Spin, Tag } from 'antd';
import cloneDeep from 'lodash.clonedeep';
import { connect } from 'react-redux';

import ReactEcharts from '../../Echarts/Echarts';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';
import { config } from '../../constant';

import { trendLabelTranslation } from '../../../Utils/Adapter/translationAdapter';

import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { arrayOfObjects } from '../../../Mock/MockJson';


const LineBarArea = (props) => {

  const [option, setOption] = useState(getOption());
  const [loading, setLoading] = useState(false);
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);

  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());
  let theme = props.selectedThemeing;

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    selectedThemeing,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData(props, selectedThemeing);
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear
  ]);

  const getData = async () => {
    requestCheck.current = false;
    let theme = props.selectedThemeing;
    let json = [];
    let { graphprops } = props;
    setLoading(true);
    setErrorInAPI(false);
    setNoDataInDB(false);
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = arrayOfObjects;
      requestCheck.current = true;
      setLoading(false);
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
          setLoading(false);
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
          setLoading(false);
        }
      }
    }
    if (
      (json && json.message) ||
      (Array.isArray(json) &&
        json.length === 0 &&
        graphprops.enableMock &&
        graphprops.enableMock !== true)
    ) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      if (json && Array.isArray(json)) {
        let dates = [];
        let values = [];
        let name = '';
        let Names = [];
        let seriesarray = [];
        let legendsdata = [];
        json.map((val) => {
          if (val.Name !== name) {
            if (Names.indexOf(val.Name) === -1) {
              Names.push(val.Name);
              name = val.Name;
              legendsdata.push({
                name: val.Description,
                icon: 'roundRect',
                textStyle: {
                  color: theme === 'lightTheme' ? 'black' : 'white',
                  fontSize: 18,
                  fontWeight: 'bold'
                }
              });
            }
          }
          return {};
        });
        let yAxisData = [];

        if (props.graphprops.YAxis) {
          yAxisData = [...props.graphprops.YAxis];
        }
        let yaxis = yAxisData.map((value, index) => {
          let colorss = [];
          colorss = [...props.graphprops.colors];
          let axis = {};
          axis.splitLine = {
            show: true,
            lineStyle: {
              color: '#504c4c'
            }
          };
          axis.triggerEvent = true;
          axis.axisLine = {
            lineStyle: {
              color:
                colorss[index] !== undefined
                  ? value && value.tags && value.tags.length > 1
                    ? 'white'
                    : colorss[index]
                  : 'white'
            }
          };
          axis.max = value.max;
          axis.min = value.min;
          axis.offset = value.offset;
          axis.interval = value.interval;
          axis.position = value.position;
          axis.name = value.name;
          axis.tags = value.tags;
          return axis;
        });
        yaxis.unshift({
          splitLine: {
            show: true,
            lineStyle: {
              color: '#504c4c'
            }
          },
          triggerEvent: true,
          axisLine: {
            lineStyle: {
              // color: theme === "lightTheme" ? "black" : "white",
            }
          },
          // axisLabel: { fontSize: 15 },
          tags: []
        });

        Names.map((tagval, tagindex) => {
          values = [];
          json.map((jsonval) => {
            if (Names[0] === jsonval.Name && tagindex === 0) {
              let date =
                graphprops && graphprops.type === 'live'
                  ? moment
                    .utc(jsonval.DateTime)
                    .tz(props.currentTimeZone)
                    .format('DD/MM/YYYY HH:mm:ss')
                  : moment(jsonval.DateTime).format('DD/MM/YYYY HH:mm:ss');
              dates.push(date);
            }
            if (tagval === jsonval.Name) {
              values.push(jsonval.Value);
            }
            return {};
          });
          let graphTypeData = [];
          if (
            props &&
            props.graphprops &&
            props.graphprops.LineBarArea &&
            props.graphprops.LineBarArea.GraphType
          ) {
            graphTypeData = JSON.parse(props.graphprops.LineBarArea.GraphType);
          }

          let graphtype = graphTypeData.map((value) => {
            let Type = {};
            Type.tags = value.tags;
            Type.type = value.type;
            return Type;
          });

          graphtype.map((value) => {
            if (value.tags.indexOf(tagval) !== -1) {
              seriesarray.push({
                name: legendsdata[tagindex]['name'],
                data: values,
                type: 'line',
                smooth: true
              });
              // if (value.type === 'line') {
              //   seriesarray.push({
              //     name: legendsdata[tagindex]['name'],
              //     data: values,
              //     type: 'line',
              //     smooth: true
              //   });
              // } else if (value.type === 'area') {
              //   seriesarray.push({
              //     name: legendsdata[tagindex]['name'],
              //     data: values,
              //     type: 'line',
              //     areaStyle: {},
              //     smooth: true
              //   });
              // } else if (value.type === 'bar') {
              //   seriesarray.push({
              //     name: legendsdata[tagindex]['name'],
              //     data: values,
              //     type: 'bar',
              //     smooth: true
              //   });
              // } else {
              //   seriesarray.push({
              //     name: legendsdata[tagindex]['name'],
              //     data: values,
              //     type: 'line',
              //     smooth: true
              //   });
              // }
            } else {
              if (value.type === 'line') {
                seriesarray.push({
                  // name: legendsdata[tagindex]['name'],
                  // data: values,
                  type: 'line',
                  smooth: true
                });
              } else if (value.type === 'area') {
                seriesarray.push({
                  name: legendsdata[tagindex]['name'],
                  data: values,
                  type: 'line',
                  areaStyle: {},
                  smooth: true
                });
              } else if (value.type === 'bar') {
                seriesarray.push({
                  name: legendsdata[tagindex]['name'],
                  data: values,
                  type: 'bar',
                  smooth: true
                });
              } else {
                seriesarray.push({
                  name: legendsdata[tagindex]['name'],
                  data: values,
                  type: 'line',
                  smooth: true
                });
              }
            }
            return {};
          });
          return {};
        });

        const option = cloneDeep(getOption());

        let series = await trendLabelTranslation(seriesarray, props.translationCache);

        option.xAxis.data = [...dates];
        option.yAxis = [...yaxis];
        option.series = [...series];
        option.legend = [...legendsdata];
        setOption(option);
        setRefreshDateTime(moment());
      }
    }
    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  };

  function getOption() {
    let theme = props.selectedThemeing;

    let option = {
      legend: {
        textStyle: { color: theme === 'lightTheme' ? 'black' : 'white' },
        data: [
          {
            name: 'test1',
            icon: 'roundRect',
            textStyle: {
              // fontSize: 15,
            }
          }
        ]
      },
      tooltip: {
        trigger: 'axis',
        textStyle: {
          // fontSize: 15,
        }
      },
      toolbox: {
        showTitle: false,
        itemSize: 25,
        feature: {
          saveAsImage: {
            title: 'download',
            name: props.graphprops.title,
            backgroundColor: theme === 'lightTheme' ? 'white' : 'black'
          }
        }
      },
      xAxis: {
        type: 'category',
        data: props.graphprops,
        axisLine: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisTick: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisLabel: {
          color: theme === 'lightTheme' ? 'black' : 'white'
          // fontSize: 15,
        }
      },
      yAxis: {
        type: 'value',
        axisLine: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        }
      },

      dataZoom: [
        {
          type: 'slider',
          show: true,
          start: 0,
          end: 100,

          backgroundColor: '#9a9191',
          textStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        {
          type: 'inside',
          start: 0,
          end: 100
        }
      ]
    };
    return option;
  }
  return (
    <Fragment>
      {graphprops && graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}

      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <span>
          {loading === false ? (
            <ReactEcharts
              option={option}
              notMerge={true}
              lazyUpdate={true}
              style={{ height: '80%', width: '100%' }}
              className="react_for_echarts"
            />
          ) : (
            <div
              style={{
                textAlign: 'center',
                color: theme === 'lightTheme' ? 'black' : 'white',
                marginTop: '10%'
              }}
            >
              <h2 style={{ color: 'black' }}>
                <Spin spinning={loading} tip="Loading..." ></Spin>
              </h2>
            </div>
          )}
        </span>
      )}
    </Fragment>
  );
};


const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    selectedThemeing: state.ThemeReducer.themeing
  };
};

export default connect(mapStateToProps)(LineBarArea);
